module.exports = __webpack_public_path__ + "static/img/6设计师3.0695dbd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/设计市场/6设计师3.png
// module id = ukG0
// module chunks = 1